import { useContext, useState, useEffect } from 'react';
import { SidebarLayout } from 'layouts/Sidebar/SidebarLayout';
import { HomeSuperAdminyAnalista } from './HomeSuperAdminyAnalista';
import { HomeUsuario } from './HomeUsuario';
import usuariosService from 'services/usuarios';
import { DICTONARY } from 'const/Dictonary';
import { useCallback } from 'react';
import { formateoDataSeparadorMiles } from 'helpers/formateoNumeros';
import { AuthContext } from 'context';
import useLegalAcceptance from 'hooks/useLegalAcceptance';
import LegalAcceptanceModal from 'components/LegalAcceptanceModal/LegalAcceptanceModal';

const HomeUsuarioLogeado = () => {
  const { logeduser, token, refrescarSesion, isTieneSucursales, logout } =
    useContext(AuthContext);

  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const tieneNegocioRegistrado =
    logeduser && isTieneSucursales() ? true : false; //TODO: VERIFICAR

  const [usuarioInvitado, setUsuarioInvitado] = useState(
    localStorage.getItem('verificaUsuarioSucursal') || null
  );
  // Hook para la aceptación legal al ingresar al home
  const {
    open, // open del modal de aceptación legal
    handleClose: handleClickCloseRedirect, // handleClose del modal de aceptación legal
    handleAccept: handleClickAceptarcionLegal, // handleAccept del modal de aceptación legal
    values, // values del modal de aceptación legal
    handleChange, // handleChange del modal de aceptación legal
    puedeContinuar, // puedeContinuar del modal de aceptación legal
    handleLogout, // handleLogout del modal de aceptación legal
    isProcessing // isProcessing del modal de aceptación legal
  } = useLegalAcceptance('home'); // No se ocupa onAccepted porque no se necesita ninguna acción extra al aceptar la legalidad

  useEffect(() => {
    // Refrescar usuario si el usuario es un usuario invitado al cual se le agrego una sucursal
    if (usuarioInvitado) {
      refrescarSesion(token);
      localStorage.removeItem('verificaUsuarioSucursal');
    }
  }, [refrescarSesion, token, usuarioInvitado]);

  const cargarDatos = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await usuariosService.getResumenUsuario(
        DICTONARY.INTERCEPTOR.DESACTIVADO
      );
      const error = response.data.error;
      if (error) throw new Error('ERROR_CARGAR_RESUMEN');
      const dataResumenUsuarios = response.data;
      const datosFormateados = formateoDataSeparadorMiles(dataResumenUsuarios);

      setData(datosFormateados);
    } catch (error) {
      setData({});
      console.log('Error al cargar resumen ', error);
    }
    setIsLoading(false);
  }, [logeduser?.codigoUsuario]);

  useEffect(() => {
    if (logeduser && logeduser.codigoUsuario) {
      cargarDatos();
    }
  }, [cargarDatos, logeduser?.codigoUsuario]);

  return (
    <>
      <SidebarLayout>
        <HomeSuperAdminyAnalista
          logeduser={logeduser}
          isLoading={isLoading}
          data={data}
        />

        <HomeUsuario
          data={data}
          tieneNegocioRegistrado={tieneNegocioRegistrado}
          isLoading={isLoading}
        />
      </SidebarLayout>
      {/* Mostrar modal de aceptación legal si es necesario */}
      <LegalAcceptanceModal
        open={open}
        onClose={handleClickCloseRedirect}
        onAccept={handleClickAceptarcionLegal}
        onLogout={handleLogout}
        isProcessing={isProcessing}
        values={values}
        onChange={handleChange}
        puedeContinuar={puedeContinuar}
      />
    </>
  );
};

export default HomeUsuarioLogeado;
